<template>
  <div
    :class="[
      $style.base,
      {
        [$style.smallScreen]: $screen === 's'
      }
    ]"
    v-test="'sms-credits-page'"
  >
    <BaseHeading>{{ $t('sms_credits.heading') }}</BaseHeading>

    <Flex direction="column">
      <div :class="$style.currentBalance">
        <Flex direction="column">
          <BaseHeading size="s">
            {{ $t('sms_credits.balance') }}
          </BaseHeading>
          <BaseText
            size="l"
            bold
            :color="!currentBalance ? 'error' : 'default'"
            v-test="'credit-balance'"
          >
            {{ currentBalance }}
            {{ $t('sms_credits.credit', currentBalance) }}
          </BaseText>
          <BaseButton
            v-if="isRouteAllowed('messages-purchase-credits')"
            :routerLink="{
              name: 'messages-purchase-credits'
            }"
            v-test="'sms-credits-purchase'"
          >
            {{ $t('sms_credits.button_submit') }}
          </BaseButton>
        </Flex>
        <img src="/img/admin/sms-credits.svg">
      </div>
      <BaseAlert
        v-if="isRouteAllowed('messages-purchase-credits') && unleash.isEnabled('BlackFridaySMSOffer')"
        :text="$t('messages.black_friday_offer.heading')"
        :primaryAction="{
            text: $t('global.actions.claim_offer'),
            routerLink: {
              name: 'messages-purchase-credits'
            }
          }"
        v-test="'black-friday-offer'"
      />
    </Flex>
  </div>
</template>

<script lang="ts">
export default {
  name: 'SmsCredits',
};
</script>

<script
  setup
  lang="ts"
>
import { isRouteAllowed } from '@/router/helpers';
import { useCompanyStore } from '@/stores/company';
import unleash from '@/unleash';

const { company, isUk } = useCompanyStore();
const currentBalance = ref(company.smsCredits || 0);
</script>

<style
  lang="scss"
  module
>
.base {
  display: flex;
  flex-direction: column;
  gap: $spacing;
}
.currentBalance {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  img {
    width: 100px;
  }
}

.amountsWrap {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: $spacing;

  & > * {
    width: calc(50% - #{$spacing * 0.5});
  }
}

.amountPrices {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}

.customAmount {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: $spacing * 0.5;
}

.customAmountRight {
  text-align: right;
}

.cardWrap {
  cursor: pointer;
}

.footer {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-end;
  gap: $spacing * 2;
}

.footerAlertContainer {
  align-self: stretch;
}
</style>
